import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import { __decorate } from "tslib";
import { Component, inject } from 'intact-react';
import template from './item.vdt';
import { bind } from '../utils';
import { useItemKeyboard } from './useKeyboard';
import { DROPDOWN } from './dropdown';
import { DROPDOWN_MENU } from './menu';
import { Dropdown as ExportDropdown, DropdownMenu as ExportDropdownMenu } from '.';
import { useConfigContext } from '../config';
var typeDefs = {
  disabled: Boolean,
  hideOnSelect: Boolean,
  _isFocus: null
};
var defaults = function defaults() {
  return {
    hideOnSelect: true
  };
};
export var DropdownItem = /*#__PURE__*/function (_Component) {
  _inheritsLoose(DropdownItem, _Component);
  function DropdownItem() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.parentDropdown = void 0;
    _this.dropdown = null;
    _this.keyboard = null;
    _this.dropdownMenu = null;
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = DropdownItem.prototype;
  _proto.init = function init() {
    this.dropdown = inject(DROPDOWN);
    this.parentDropdown = this.hasSubMenu();
    this.dropdownMenu = inject(DROPDOWN_MENU);
    this.keyboard = useKeyboardForDropdownItem(this);
  };
  _proto.select = function select() {
    if (this.parentDropdown) return;
    // trigger select event firstly for Cascader update values
    this.trigger('select');
    if (this.get('hideOnSelect')) {
      // hide all dropdowns
      var dropdown = this.dropdown;
      do {
        dropdown.hide(true);
      } while (dropdown = dropdown.dropdown);
    }
  };
  _proto.hasSubMenu = function hasSubMenu() {
    // wrapped by Dropdown rather than DropdownMenu
    var parent = this.$senior;
    while (parent) {
      // Tooltip extends Dropdown, it's also a instance of Dropdown
      // so use constructor to detect
      // if (parent instanceof DropdownMenu) {
      if (parent.constructor === ExportDropdownMenu) {
        return;
      }
      if (parent.constructor === ExportDropdown) {
        return parent;
      }
      parent = parent.$senior;
    }
  };
  _proto.onClick = function onClick(e) {
    if (this.get('disabled')) return;
    // Some cases, the item may been removed after click immediately
    // and the menu will hide, because it can't detect it contains
    // the removed item.
    // Set the ignore flag to prevent menu from hidding
    // 
    // @Change Cascader need click item to toggle show an hide
    // (e as IgnoreClickEvent)._ignore = true;
    this.trigger('click', e);
    this.select();
  };
  return DropdownItem;
}(Component);
DropdownItem.template = template;
DropdownItem.typeDefs = typeDefs;
DropdownItem.defaults = defaults;
__decorate([bind], DropdownItem.prototype, "onClick", null);
function useKeyboardForDropdownItem(instance) {
  var dropdownMenu = inject(DROPDOWN_MENU);
  var showMenu = function showMenu() {
    if (instance.parentDropdown) {
      instance.parentDropdown.show(true);
    }
  };
  return useItemKeyboard({
    onShowMenu: showMenu,
    onHideMenu: function onHideMenu() {
      dropdownMenu.dropdown.hide(true);
    },
    onSelect: function onSelect() {
      showMenu();
      instance.select();
    }
  });
}